import { connect } from 'react-redux';
import { userSubmitChangePasswordForm } from 'store/actionCreators/user';
import ChangePassword from 'components/ChangePassword';

const mapDispatchToProps = {
  onSubmit: userSubmitChangePasswordForm,
};

export default connect(
  null,
  mapDispatchToProps,
)(ChangePassword);
